import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ProProvider } from "@/contexts/ProContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Settings from "@/pages/Settings";
import NewBill from "@/pages/NewBill";
import JoinGroup from "@/pages/JoinGroup";
import { ImpressumPage, PrivacyPage } from "@/pages/ContentPages";
import FeedbackPage from "@/pages/Feedback";
import SponsorsPage from "@/pages/Sponsors";
import AdminPage from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import ProDashboard from "@/pages/ProDashboard";
import Friends from "@/pages/Friends";
import FriendDetail from "@/pages/FriendDetail";
import { AnalyticsBeacon } from "@/components/AnalyticsBeacon";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <ProProvider>
              <AnalyticsBeacon />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/join/:code" element={<JoinGroup />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/pro-dashboard" element={<ProtectedRoute><ProDashboard /></ProtectedRoute>} />
                <Route path="/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
                <Route path="/friends" element={<ProtectedRoute><Friends /></ProtectedRoute>} />
                <Route path="/friends/:id" element={<ProtectedRoute><FriendDetail /></ProtectedRoute>} />
                <Route path="/groups/:id" element={<ProtectedRoute><GroupDetail /></ProtectedRoute>} />
                <Route path="/groups/:id/bills/new" element={<ProtectedRoute><NewBill /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                <Route path="/impressum" element={<ImpressumPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/sponsors" element={<SponsorsPage />} />
                <Route path="/feedback" element={<ProtectedRoute><FeedbackPage /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
                <Route path="/auth/callback" element={<AuthCallback />} />
              </Routes>
              <Toaster richColors position="top-right" theme="dark" />
            </ProProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
